import Backbone from 'backbone'
import _ from 'lodash'
import $ from 'jquery'
import template from './mass-edit-form.hbs'
import selects from 'scoreboard/components/selects'
import FormView from 'scoreboard/components/form-view'
import formHelper from 'scoreboard/components/form-helper'
import dropdown from 'scoreboard/components/dropdown'
import DateInput from 'scoreboard/components/date-input'
import calendars from 'scoreboard/components/calendars'
import currency from 'scoreboard/components/currency'
import i18n from 'scoreboard/components/i18n'
import MarkedField from 'scoreboard/components/marked-field'
import appDisplay from 'scoreboard/components/app-display'
import ConfirmPrompt from 'scoreboard/components/confirm-prompt'
import numericEvaluator from 'scoreboard/components/evaluators/numeric-evaluator'
import requiredValidator from 'scoreboard/components/validators/required-validator'
import numericValidator from 'scoreboard/components/validators/numeric-validator'
import TagsChooser from 'scoreboard/components/tags-chooser'
import PrincipalPanel from 'scoreboard/components/principal-panel'
import UpdatersPanel from 'scoreboard/scorecards/edit/scorecards-updaters-panel'
import WeightDateTable from 'scoreboard/scorecards/edit/weight-date-table'
import OnOffToggle from 'scoreboard/components/on-off-toggle'
import TextReplacement from './text-replacement'
import CovertButtonTooltips from 'scoreboard/components/covert-button-tooltips'
import config from 'scoreboard/components/config'

var MassEditForm = Backbone.View.extend({
	tagName: 'form',
	className: 'mass-edit-form form',

	events: {
		'click .cancel': 'cancel',
		'change .add-updaters' : 'renderUpdatersPanel',
		'change .add-owners': 'renderOwnersPanel',
		'change	.replacement-type' : 'renderTextReplacementInputs'
	},

	/**
	 * The Mass Edit dialog for modify multiple selected scorecard items
	 * @constructs
	 * @param {Object} options
	 * @param {Object} options.field - the selected mass edit field {value, label, icon, group}
	 * @param {Array} options.scorecardItemIds - the ids of the items selected for mass edit
	 * @param {Boolean} options.showModifyWeightMessage- if a message should be
	 * shown when modifying weights (TODO not yet implemented)
	 * @param {Tag[]} [options.globalTags] all existing tags for the select options
	 */
	initialize: function(options) {
		this.options = options || {}
		this.request = this.options.request
		this.scorecardItemIds = this.options.scorecardItemIds
		this.field = this.options.field
		this.massEditField = this.options.field.value
		this._markedFields = []
		// #40675 allow clean submission for fields with only a dropdown
		let cleanSubmissionFields = [
			'type',
			'aggregation-type',
			'currency-code',
			'calendar-id',
			'data-type',
			'missing-value-treatment',
			'rollup-aggregation-type',
			'scoring-type-id',
			'higher-better',
			'yes-good',
			'precision',
			'weight', // the weight form is pre-populated with initial value of 1
			// #45205 start and archive dates may be set to blank
			'start',
			'archive'
		]
		let allowCleanSubmission = _.includes(cleanSubmissionFields, this.massEditField)
		this.formView = new FormView({
			el: this.el,
			submit: this.submit.bind(this),
			allowCleanSubmission
		})
		this.showModifyWeightMessage = this.options.showModifyWeightMessage
	},

	render: function() {
		this.$el.empty().append(template(this.context()))
		this.formView.start()
		// set up selects
		dropdown.idLabels(this.$('select.calendar').empty(), calendars.calendars)
		if (_.size(currency.all()) > 1) {
			dropdown.currency(this.$('.currency-code'))
		}
		dropdown.unit(this.$('select.unit'))
		dropdown.scoringType(this.$('select.scoring-type'))
		this.renderDefaultThresholdSelect()
		selects(this.$('select'))
		// set up date controls
		this.startSelector = new DateInput({
			el: this.$('.starts-on')
		}).render()
		this.archiveSelector = new DateInput({
			el: this.$('.archives-on')
		}).render()
		// weight

		this.weightField = new WeightDateTable({
			el: this.$('.weight-row'),
			formView: this.formView
		}).render()
		this.tagsChooser = new TagsChooser({
			el: this.$('.tags'),
			globalTags: this.options.globalTags
		}).render()
		this.thresholdValueField = new MarkedField({
			el: this.$('.threshold-value'),
			evaluator: numericEvaluator,
			validator: [numericValidator]
		}).render()
		// default threshold override fields
		this.thresholdOverrideToggle = new OnOffToggle({
			name : 'thresholdOverride',
			checked : false,
			label: i18n.get('scorecards.node.metric.thresholds.replace')
		})
		this.thresholdOverrideToggle.on('change', function() {
			this.formView.change()
			this.$('.threshold-override-date').toggleClass('is-not-displayed',
				!this.thresholdOverrideToggle.val())
		}.bind(this))
		this.$('.toggle-container').append(this.thresholdOverrideToggle.el)
		this.thresholdOverrideToggle.render()
		this.thresholdOverrideEarliestDate = new DateInput({
			el: this.$('[name=thresholdOverrideEarliestDate]'),
			required: false
		}).render()
		this.covertButtonTooltips = new CovertButtonTooltips({ el: this.el })
		this.showFieldValueInput()
		return this
	},

	context: function() {
		return {
			label: this.field.label
		}
	},

	/**
	 * Renders a dropdown of threshold names for updating default threshold values.
	 * In addition to the thresholds for standard scoring types, this will
	 * include any uniquely-named thresholds for custom numeric scoring types
	 * (#49259)
	 */
	renderDefaultThresholdSelect: function () {
		let selectOptions = this.buildThresholdSelectOptions()
		dropdown.idLabels(this.$('select.threshold').empty(), selectOptions)
	},

	/**
	 * Builds the options for the default threshold select
	 * Includes thresholds for standard scoring types and any uniquely-named
	 * thresholds for custom numeric scoring types
	 * (#49259)
	 */
	buildThresholdSelectOptions: function () {
		// some threshold labels will be mr.p keys (standard scoring types),
		// and some will be text (custom number)
		let thresholdLabels= _(config.scoringTypes)
			.filter(s => !s.isCustomText)
			.map('thresholds')
			.flatten()
			.values()
			.map('label')
			.filter(t => !_.isNil(t))
			.uniq()
			.value()

		let selectOptions = []
		_.each(thresholdLabels, thresholdLabel => {
			let option = {
				id: thresholdLabel,
				label: i18n.get(thresholdLabel)
			}
			// since it is possible for a custom threshold label to have the
			// same value as a resolved standard scoring type threshold label,
			// make sure we don't add a second option with the same resolved label
			if (!_.find(selectOptions, {label: option.label})) {
				selectOptions.push(option)
			}
		})
		// sort options alphabetically
		selectOptions = _.sortBy(selectOptions,
			option => option.label.toLocaleUpperCase())
		return selectOptions
	},

	// Shows/hides the field inputs based on the selected field
	showFieldValueInput: function() {
		let field = this.massEditField
		// hide all field input rows first
		this.$('.field-input-row').addClass('is-not-displayed')
		this.$('.preview-container').addClass('is-not-displayed')
		// display the selected field input row
		var selector = '.' + field + '-row'
		this.$(selector).removeClass('is-not-displayed')
		if (field === 'scoring-type-id') {
			// display warning for scoring type changes
			this.$('.banner').removeClass('is-not-displayed')
			this.$('.warning').html(i18n.get('report.customReport.massedit.thresholdWarning'))
		} else {
			this.$('.banner').addClass('is-not-displayed')
			this.$('.warning').html('')
		}
		if (field === 'owners') {
			this.renderOwnersPanel()
		}
		if (field === 'updaters') {
			this.renderUpdatersPanel()
		}
		this.$('.options-panel').toggleClass('weight-form-visible', field === 'weight')
		var isEquation = (field === 'equation')
		var isLabelOrDescription = (field === 'label' || field === 'description')
		this.$('.options-panel')
			.removeClass('is-not-displayed')
			.toggleClass('has-preview', isLabelOrDescription)
		if (isLabelOrDescription || isEquation) {
			this.populateReplacementTypeSelect(field)
			this.renderTextReplacementInputs()
		}
		this.$('.preview-container').toggleClass('is-equation', isEquation)
		this.$('.options-panel').toggleClass('is-not-displayed', isEquation)
	},

	// render owners panel
	// #16607 for adding owners, only list principals who are potential assignees
	// for removing owners, anyone can be removed regardless of group membership
	renderOwnersPanel: function() {
		let addOwner = this.$('.add-owners').val() === 'true'
		// #39307 Disallow view only users from being owners
		let params = $.param({
			includeViewOnly: false,
			includeActiveViewers: true
		})
		this.ownersPanel = new PrincipalPanel({
			url: addOwner ? `api/admin/mass-edit/potential-assignees?${params}` : null,
			headingKey: 'common.owners',
			placeholderKey: 'admin.group.addUserGroup'
		})
		this.ownersPanel.on('change', this.formView.change.bind(this.formView))
		this.$('.owners').html(this.ownersPanel.el)
		this.ownersPanel.render()
	},

	//render updaters panel
	// #16607 for adding updaters, only list principals who are potential assignees
	// for removing updaters, anyone can be removed regardless of group membership
	renderUpdatersPanel: function () {
		let addUpdater = this.$('.add-updaters').val() === 'true'
		this.updatersPanel = new UpdatersPanel({
			url: addUpdater ? 'api/admin/mass-edit/potential-assignees' : null,
			headingKey: 'common.updaters',
			placeholderKey: 'admin.group.addUserGroup'
		})
		this.updatersPanel.on('change', this.formView.change.bind(this.formView))
		this.$('.updaters').html(this.updatersPanel.el)
		this.updatersPanel.render()
		// show "update thresholds" checkbox if adding updater
		this.$('.updaters .principal-panel').toggleClass('principal-panel-updaters', addUpdater)
	},

	populateReplacementTypeSelect: function (field) {
		var replacementTypes = []
		var isLabelOrDescription = (field === 'label' || field === 'description')
		if (isLabelOrDescription) {
			var fieldKey = field === 'label' ? 'name' : 'description'
			replacementTypes = [
				{id: 'entire', label: 'report.customReport.massedit.replaceEntire' + _.capitalize(fieldKey)},
				{id: 'exact-phrase', label: 'report.customReport.massedit.replaceExactPhrase'},
				{id: 'between-phrases', label: 'report.customReport.massedit.replaceBetweenTwoPhrases'},
				{id: 'prepend', label: 'report.customReport.massedit.prependTextTo' + _.capitalize(fieldKey)},
				{id: 'append', label: 'report.customReport.massedit.appendTextTo' + _.capitalize(fieldKey)}
			]
		} else {
			replacementTypes = [{id: 'exact-phrase', label: 'report.customReport.massedit.replaceExactPhrase'}]
		}
		this.$('select.replacement-type').empty()
		dropdown.idLabels(this.$('select.replacement-type'), replacementTypes)
		// we don't need to display the replacement type for equations, since the only choice 'exact phrase'
		if (isLabelOrDescription) {
			this.$('.replacement-type-row').removeClass('is-not-displayed')
		}
	},

	renderTextReplacementInputs: function() {
		var replacementType = this.$('.replacement-type').val()
		var massEditField = this.massEditField
		// text replacement fields and preview
		this.textReplacement = new TextReplacement({
			replacementType: replacementType,
			massEditField
		})
		this.$('.preview-container').empty().removeClass('is-not-displayed').append(this.textReplacement.el)
		this.textReplacement.render()

		// newText field is only required when updating entire label
		// to prevent setting a blank label on a scorecard item
		_.invokeMap(this._markedFields, 'remove')
		if (replacementType === 'entire' && massEditField === 'label') {
			this._markedFields.push(new MarkedField({
				el: this.$('.new-text'),
				validator: requiredValidator
			}).render())
		}
	},

	submit: function() {
		//checks to see any of the nodes being modified have weights with existing time ranges
		//if so this will present a second level dialog to confirm that changing the weights will
		//overwrite the existing ones
		let editingWeights = this.massEditField == 'weight'
		let weights = editingWeights ? this.weightField.gather() : []
		if (this.showModifyWeightMessage && editingWeights) {
			let cpv = new ConfirmPrompt({
				titleKey: 'report.customReport.massedit.confirmModifyWeightPeriods.title',
				messageKey: 'report.customReport.massedit.confirmModifyWeightPeriods.msg',
				confirmLabel: 'common.replace',
				cancelLabel: 'common.cancel',
				onConfirm: () => {
					this.showModifyWeightMessage = false
					this.submit()
				}
			})
			cpv.once('cancel', () => this.cancel())
			appDisplay.dialog(cpv)
			return
		}

		var data = _.extend({scorecardItemIds: this.scorecardItemIds, weights}, formHelper.readFromDom(this.el))
		data.massEditField = this.massEditField
		if (this.ownersPanel) {
			data.owners = this.ownersPanel.getPrincipals()
		}
		if (this.updatersPanel) {
			data.updaters = this.updatersPanel.getPrincipals()
		}
		data.thresholdOverride = this.thresholdOverrideToggle.val()
		return $.ajax({
			method: 'post',
			url: 'api/admin/mass-edit',
			data: JSON.stringify(data),
			success: function(result) {
				let payload = editingWeights ? _.extend({weights},result) : result
				this.trigger('done', payload)
			}.bind(this),
			error: function (response) {
				this.formView.error(response)
			}.bind(this)
		})
	},

	cancel() {
		this.trigger('cancel')
	},

	remove: function() {
		Backbone.View.prototype.remove.apply(this, arguments)
		_.invokeMap([this.formView, this.startSelector, this.archiveSelector,
			this.weightField, this.tagsChooser, this.ownersPanel, this.updatersPanel,
			this.thresholdValueField, this.toggle, this.thresholdOverrideEarliestDate,
			this.textReplacement, this._markedFields, this.covertButtonTooltips], 'remove')
	}

})

export default MassEditForm

MassEditForm.__filename__ = 'admin/mass-edit/mass-edit-form.js'
